module.exports = __webpack_public_path__ + "img/onsen2.d6095613.jpg";